module.exports = __webpack_public_path__ + "img/course101_summary_unit_timelines.8ce5361a.png";